<div class="container" [formGroup]="userForm" autocomplete="off">
    <div class="row py-3">
        <div class="col-1 cursor" (click)="onBackClick()">
            <div class="input-group flex-nowrap">
                <div class="input-group-prepend">
                    <i class="fas fa-chevron-circle-left font-size-16" style="color: #1d2124;"></i>
                </div> 
            </div>
        </div>
        <div class="col text-center">
            <h4>Change Password</h4>
        </div>
    </div>
    <div class="row form-group" *ngIf="successMessage">
        <div class="col text-success text-center">
            {{successMessage}}
        </div>
    </div>
    <div class="row form-group" *ngIf="errorMessage">
        <div class="col text-danger text-center">
            {{errorMessage}}
        </div>
    </div>
    <div class="row form-group">
        <div class="col text-center">
            <div [ngClass]="{'d-block': redirect, 'd-none': !redirect }">redirecting in <span id="redirect"></span>
            </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col">
            <label for="" class="font-weight-bold">Current Password</label>
            <input autocomplete="off" maxlength="50" type="password" class="form-control" placeholder="Current Password"
                formControlName="currentpassword"
                [ngClass]="{'has-error': ((userForm.get('currentpassword').touched || userForm.get('currentpassword').dirty) &&  userForm.get('currentpassword').errors)}" />
        </div>
    </div>
    <div class="row form-group">
        <div class="col">
            <label for="" class="font-weight-bold">New Password</label>
            <input autocomplete="off" maxlength="50" type="password" class="form-control" placeholder="New Password"
                formControlName="newpassword"
                [ngClass]="{'has-error': ((userForm.get('newpassword').touched || userForm.get('newpassword').dirty) &&  userForm.get('newpassword').errors)}" />
                <div class="row">
                    <small class="text-orange col">* Minimum 4 letters</small>
                    <!--<small id="password" class="form-text text-left cursor col" [popover]="popTemplate"-->
                        <!--popoverTitle="" [outsideClick]="true" placement="bottom">-->
                        <!--Click for password requirements-->
                    <!--</small>-->
                    <!--<ng-template #popTemplate>-->
                        <!--<p class="m-0">min of 6 & max of 20 chars</p>-->
                        <!--<p class="m-0">1 uppercase letter</p>-->
                        <!--<p class="m-0">1 lowercase letter</p>-->
                        <!--<p class="m-0">1 digit and special character</p>-->
                    <!--</ng-template>-->
                </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col">
            <label for="" class="font-weight-bold">Confirm Password</label>
            <input autocomplete="off" maxlength="50" type="password" class="form-control" placeholder="Confirm Password"
                formControlName="confirmpassword" (input)="passwordMatch($event)"
                [ngClass]="{'has-error': ((userForm.get('confirmpassword').touched || userForm.get('confirmpassword').dirty) &&  userForm.get('confirmpassword').errors)}" />
        </div>
    </div>
    <div class="row form-group">
        <div class="col">
            <button type="button" class="btn btn-outline-secondary btn-block bg-dark text-white"
                (click)="onChangePasswordClick()" [attr.disabled] = "active === 1 ? 'disabled' : null">Change Password</button>
        </div>
    </div>
</div>